import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ItemService {
    constructor( private http: HttpClient, private oktaService: OktaService ){};

    getNewID() {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        return this.http.get<any>( environment.azure.url + '/admin.item.generate', options);
    }

    checkID(id: number) {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        return this.http.get<any>( environment.azure.url + '/admin.item.validate/' + id, options);
    }

    checkSource(id: string) {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        return this.http.get<any>( environment.azure.url + '/admin.source.validate/' + id, options);
    }
}